import { Link } from 'react-router-dom';
import Navigation from './Navigation';

// En-tête avec logo et navigation
function Header() {
    return (
        <header className="flex justify-between items-center px-8 py-4 bg-gray-900 border-b border-gray-800">
            <Link to="/" className="text-xl font-bold text-white">Guillaume Riou</Link>
            <Navigation />
        </header>
    );
}

export default Header;